import { render, staticRenderFns } from "./OrganisationEdit.vue?vue&type=template&id=e18afed0&"
import script from "./OrganisationEdit.vue?vue&type=script&lang=ts&"
export * from "./OrganisationEdit.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports